import {useState} from 'react';
import {Box, Collapse, Group, NavLink, rem, ThemeIcon, UnstyledButton} from '@mantine/core';
import {IconChevronRight} from '@tabler/icons-react';
import classes from './NavbarLinksGroup.module.css';
import {Link} from "react-router-dom";
import {SidebarBadge} from './SidebarBadge';
import {BoNavigationGroup} from "../../types/NavigationGroup";
import {AccountService} from "../../services/AccountService";

interface LinksGroupProps {
    group: BoNavigationGroup,
    counters: Record<string, string | number>
}

export default function LinksGroup({group, counters}: LinksGroupProps) {
    const hasLinks = Array.isArray(group.links);
    const [opened, setOpened] = useState(group.initiallyOpened || false);
    const resolveSubtitle = (subtitle?: string) => {
        if (!subtitle) {
            return undefined;
        }
        const key = subtitle.split('{')[1]?.split('}')[0];
        return key ? subtitle.replace(`{${key}}`, String(counters[key] ?? '')) : subtitle;
    };
    const items = (hasLinks ? group.links : []).map((link, index) => (
        AccountService.hasAuthority(link.authority) &&
        <NavLink
            component={Link}
            className={classes.link}
            to={link.link}
            key={index}
            label={link.label}
            description={link.subtitle
                ? <span style={{display: 'inline-flex', alignItems: 'center', gap: rem(4), whiteSpace: 'nowrap', fontSize: rem(10.5)}}>
                    {link.subtitleIcon && <link.subtitleIcon style={{width: rem(11), height: rem(11)}}/>}
                    {resolveSubtitle(link.subtitle)}
                  </span>
                : undefined}
            leftSection={
                link.icon && (
                    <ThemeIcon variant="light" size={20} c={link.iconColor}>
                        <link.icon style={{width: rem(14), height: rem(14)}}/>
                    </ThemeIcon>
                )
            }
            rightSection={
                link.counters && (
                    <SidebarBadge
                        counters={counters}
                        counterKeys={link.counters}
                        isLoading={!(Object.keys(counters).length > 0)}
                        title={link.title}
                    />
                )
            }
        />
    ));

    return (
        <>
            <UnstyledButton onClick={() => setOpened((o) => !o)} className={classes.control}>
                <Group justify="space-between" gap={0}>
                    <Box style={{display: 'flex', alignItems: 'center'}}>
                        <ThemeIcon variant="outline" size={30} color={group.color ?? "lightgray"}>
                            <group.icon style={{width: rem(18), height: rem(18)}}/>
                        </ThemeIcon>
                        <Box ml="md" c={group.color}>{group.label}</Box>
                    </Box>
                    {hasLinks && (
                        <IconChevronRight
                            className={classes.chevron}
                            stroke={1.5}
                            style={{
                                width: rem(16),
                                height: rem(16),
                                transform: opened ? 'rotate(-90deg)' : 'none',
                            }}
                        />
                    )}
                </Group>
            </UnstyledButton>
            {
                hasLinks ? <Collapse expanded={opened}>{items}</Collapse> : null
            }
        </>
    );
}
